import { useState } from 'react';
import styled from 'styled-components';

import { useAppSelector } from '../../../reduxstore/hooks';
import Cards from '../Cards';
import { LoginPage } from './components/LoginPage';
import { PrimaryCard } from './containers/PrimaryCard';
import { TabBar } from './components/TabBar';

export const Scan: React.FC = () => {
	const isAuthenticated = useAppSelector(
		state => state.authReducer.accessToken
	);
	const [card, setCard] = useState('PRIMARY');

	const handleCardChange = (newStatus: string) => {
		setCard(newStatus);
	};
	return (
		<Container>
			{!isAuthenticated ? (
				<LoginPage />
			) : (
				<>
					<TabBar handleCardChange={handleCardChange} />
					<CardsContainer>
						{card === 'PRIMARY' ? <PrimaryCard /> : <Cards />}
					</CardsContainer>
				</>
			)}
		</Container>
	);
};

const Container = styled.div`
	/* padding-bottom: 60px; */
`;

const CardsContainer = styled.div`
	padding: 16px 0;
`;
